import React from "react";

import { useState } from "react";
import Login from "./Login";

import image from "../logos/stageddevice.png";
import "./CommonDashboard.css";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

import CircularProgress from "@material-ui/core/CircularProgress";
import { setStagedDevice } from "../redux/slices/stagedDeviceSlice";

import StagedDeviceTable from "./StagedDeviceTable";


function StagedDeviceDashboard() {
  const [login, setLogin] = useState(false);
  const dispatch = useDispatch();
  const headers = useSelector((state) => state.header);
  
  const [apiloading, setApiLoading] = useState(true);
  const curremmsData = useSelector((state) => state.curremms);
  
  
  function fetchData() {
    const api = localStorage.getItem("api");
    axios
      .get(api + `/device/stage`, headers)
      .then((response) => {
        dispatch(setStagedDevice(response.data));
        setApiLoading(false);
      })
      .catch((error) => {
        console.error(error);
      });
  }
  React.useEffect(() => {
    fetchData();
  }, []);

  return login == null ? (
    <Login />
  ) : (
    <>
      {apiloading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          <div className="mainContainer">
            <header>
              <figure>
                <img className="img" src={image} alt="Logo" />
              </figure>
            </header>

            <div className="tableAndButtonContainer">
             
              <div style={{ marginLeft: "10%" }}>
                <StagedDeviceTable  fetchData={fetchData}/>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default StagedDeviceDashboard;
